import { forwardRef, type Ref, type SVGProps } from "react";
const IconFacebookSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M30 16.08A14 14 0 1 0 13.81 30V20h-3.55v-4h3.55v-3c0-3.53 2.09-5.48 5.29-5.48a20.5 20.5 0 0 1 3.13.28v3.46h-1.76A2 2 0 0 0 18.2 13a1.7 1.7 0 0 0 0 .45V16h3.88l-.62 4h-3.27v10A14.06 14.06 0 0 0 30 16.08" /></svg>;
const ForwardRef = forwardRef(IconFacebookSVG);
ForwardRef.displayName = "IconFacebook";
export { ForwardRef as IconFacebook };